import { Link, useLocation } from 'react-router';

export const NavigationItem = ({
  unitWorkloadId,
  linkTo,
  navigationLabel,
}: {
  unitWorkloadId: number;
  linkTo: string;
  navigationLabel: string;
}) => {
  const location = useLocation();
  const currentView = () => {
    switch (location.pathname) {
      case `/unit-workloads/${unitWorkloadId}`:
        return 'Unit details';
      case `/unit-workloads/${unitWorkloadId}/teaching-delivery`:
        return 'Teaching delivery (TD)';
      case `/unit-workloads/${unitWorkloadId}/teaching-related-duties`:
        return 'Teaching related duties (TRD)';
      default:
        return 'Unit details';
    }
  };
  return (
    <div className="group relative">
      <Link className={currentView() === navigationLabel ? 'text-lime' : ''} to={linkTo}>
        {navigationLabel}
      </Link>
      <div
        className={`${currentView() === navigationLabel ? 'opacity-100' : 'opacity-0'} absolute left-0 -bottom-[20px] w-full h-1 bg-lime  group-hover:opacity-100 transition-opacity duration-300`}
      ></div>
    </div>
  );
};
